const cursor = {
  delay: 8,
  _x: 0,
  _y: 0,
  endX: window.innerWidth / 2,
  endY: window.innerHeight / 2,
  cursorVisible: true,
  cursorEnlarged: false,
  $dot: document.querySelector('.cursor-dot'),
  $outline: document.querySelector('.cursor-dot-outline'),

  init: function () {
    this.dotSize = this.$dot.offsetWidth;
    this.outlineSize = this.$outline.offsetWidth;
    this.setupEventListeners();
    this.animateDotOutline();
  },

  setupEventListeners: function () {
    const self = this;

    document.querySelectorAll('a, button').forEach(function (el) {
      el.addEventListener('mouseover', function () {
        const bg = window.getComputedStyle(el).backgroundColor;
        const border = window.getComputedStyle(el).borderColor;
        const hexBg = self.rgbToHex(bg);
        const hexBorder = self.rgbToHex(border);
        const tealHexes = ['#00ab9a', '#019e90'];

        if (tealHexes.includes(hexBg) || tealHexes.includes(hexBorder)) {
          self.setHoverColor(); // pink/red
        } else {
          self.setDefaultColor(); // teal
        }

        self.cursorEnlarged = true;
        self.toggleCursorSize();
        self.flashCursor();
      });

      el.addEventListener('mouseout', function () {
        self.cursorEnlarged = false;
        self.toggleCursorSize();
        self.setDefaultColor();
      });
    });

    document.addEventListener('mousedown', function () {
      self.cursorEnlarged = true;
      self.toggleCursorSize();
      self.setHoverColor();
    });

    document.addEventListener('mouseup', function () {
      self.cursorEnlarged = false;
      self.toggleCursorSize();
      self.setDefaultColor();
    });

    document.addEventListener('mousemove', function (e) {
      self.cursorVisible = true;
      self.toggleCursorVisibility();
      self.endX = e.pageX;
      self.endY = e.pageY;
      self.$dot.style.top = self.endY + 'px';
      self.$dot.style.left = self.endX + 'px';
    });

    document.addEventListener('mouseenter', function () {
      self.cursorVisible = true;
      self.toggleCursorVisibility();
      self.$dot.style.opacity = 1;
      self.$outline.style.opacity = 1;
    });

    document.addEventListener('mouseleave', function () {
      self.cursorVisible = false;
      self.toggleCursorVisibility();
      self.$dot.style.opacity = 0;
      self.$outline.style.opacity = 0;
    });
  },

  animateDotOutline: function () {
    const self = this;
    self._x += (self.endX - self._x) / self.delay;
    self._y += (self.endY - self._y) / self.delay;
    self.$outline.style.top = self._y + 'px';
    self.$outline.style.left = self._x + 'px';
    requestAnimationFrame(this.animateDotOutline.bind(self));
  },

  toggleCursorSize: function () {
    const self = this;
    if (self.cursorEnlarged) {
      self.$dot.style.transform = 'translate(-50%, -50%) scale(0.85)';
      self.$outline.style.transform = 'translate(-50%, -50%) scale(1.6)';
    } else {
      self.$dot.style.transform = 'translate(-50%, -50%) scale(1)';
      self.$outline.style.transform = 'translate(-50%, -50%) scale(1)';
    }
  },

  toggleCursorVisibility: function () {
    const self = this;
    if (self.cursorVisible) {
      self.$dot.style.opacity = 1;
      self.$outline.style.opacity = 1;
    } else {
      self.$dot.style.opacity = 0;
      self.$outline.style.opacity = 0;
    }
  },

  setHoverColor: function () {
    this.$dot.style.backgroundColor = '#e61c59';
    this.$outline.style.backgroundColor = 'rgba(230, 28, 89, 0.5)';
  },

  setDefaultColor: function () {
    this.$dot.style.backgroundColor = '#00ab9a';
    this.$outline.style.backgroundColor = 'rgba(0, 171, 154, 0.5)';
  },

  flashCursor: function () {
    const self = this;
    self.$dot.style.transition = 'background-color 0.15s ease-in-out';
    self.$outline.style.transition = 'background-color 0.15s ease-in-out';
    setTimeout(() => {
      self.$dot.style.transition = 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out';
      self.$outline.style.transition = 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out';
    }, 150);
  },

  rgbToHex: function (rgb) {
    const result = rgb.match(/\d+/g);
    if (!result || result.length < 3) return '';
    return (
      '#' +
      result
        .slice(0, 3)
        .map((x) => ('0' + parseInt(x).toString(16)).slice(-2))
        .join('')
    );
  }
};

cursor.init();
